<script setup>
import { computed, onMounted, ref } from 'vue'
import EventActiveItem from '@/components/Event/ActiveItem.vue'

const activeIndex = ref(0)
const activeItem = ref(null)

const emit = defineEmits(['updateGroup'])

const props = defineProps({
  items: Array
})

onMounted(() => {
  activeItem.value = props.items[0]
})

const updateItem = (item, index) => {
  activeIndex.value = index
  activeItem.value = item
  emit('updateGroup')
}
</script>

<template>
  <div
    class="course-events-row grid grid-cols-4"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="course-events-row-item border-y first:border-l border-r border-border h-full w-full "
    >
      <div
        class="course-events-row-item-wrapper py-4 flex flex-col items-center justify-center"
        :class="{ 'bg-secondary': activeIndex === index }"
        @click="updateItem(item, index)"
      >
        <span
          class="text-xl text-headline mb-2"
        >
          {{ item.dates[0].day }}
        </span>
        <span
          class="text-base text-headline uppercase"
        >
          {{ item.dates[0].month.slice(0, 3) }}
        </span>
      </div>
    </div>
    <EventActiveItem
      v-if="activeItem"
      :activeItem="activeItem"
    />
  </div>
</template>


<style lang="scss" scoped>

</style>
